import { Record } from "../../components/record/Record";
import { Records } from "../../components/records/Records";
import { tabs } from "./eegRecordingTabs";
import { DetailTabs } from "../../components/detailTabs/DetailTabs";
import { EntityForm } from "../../components/entityForm/EntityForm";
import { Groups } from "../../components/groups/Groups";
import { eegRecordingOptions } from "./eegRecordingOptions";
import { RecordsRelated } from "../../components/recordsRelated/RecordsRelated";
import { eegDataFieldsQuery } from "../eeg-data/eegDataRoutes";
import { EEGAnalysis } from "./eeg-analysis/EEGAnalysis";
import { EegRecordingHeader } from "./EegRecordingHeader";

export const eegRecordingFieldsQuery = [
    "*.*",
    "eeg_evaluation.eeg_session.start_date",
    "eeg_evaluation.eeg_session.treatment.client.client_id",
    "eeg_evaluation.eeg_session.treatment.client.user_id.first_name",
    "eeg_evaluation.eeg_session.treatment.client.user_id.last_name",
    "eeg_evaluation.eeg_session.treatment.client.user_id.avatar",
    "eeg_evaluation.eeg_session.technician.user_id.first_name",
    "eeg_evaluation.eeg_session.technician.user_id.last_name",
    "eeg_evaluation.eeg_session.technician.user_id.avatar",
    "eeg_evaluation.eeg_session.treatment.id",
].join(",");

export const eegRecordingRoutes = [
    {
        path: "/eeg_recording",
        element: <Records entity="eeg_recording" fieldsQuery={eegRecordingFieldsQuery} />,
    },
    {
        path: "/eeg_recording/:id",
        element: (
            <Record
                entity="eeg_recording"
                type="detail"
                fieldsQuery={eegRecordingFieldsQuery}
                header={<EegRecordingHeader />}
                body={<DetailTabs tabs={tabs} />}
            />
        ),
        children: [
            {
                path: "/eeg_recording/:id/detail",
                element: <Groups groupsOptions={eegRecordingOptions.groupsOptions} />,
            },
            {
                element: (
                    <RecordsRelated
                        entity="eeg_data"
                        fieldsToQuery={eegDataFieldsQuery}
                        fieldToFilter="eeg_recording"
                        recordsOptions={{ relatedRecords: { hideCreationButton: true } }}
                    />
                ),
                path: "/eeg_recording/:id/eeg_data",
            },

            {
                element: <EEGAnalysis type="current" />,
                path: "/eeg_recording/:id/eeg_analysis",
            },
        ],
    },
    {
        path: "/eeg_recording/:id/update",
        element: (
            <Record
                entity="eeg_recording"
                fieldsQuery={eegRecordingFieldsQuery}
                type="update"
                body={<EntityForm groupsOptions={eegRecordingOptions.groupsOptions} />}
            />
        ),
    },
    {
        path: "/eeg_recording/create",
        element: (
            <Record
                entity="eeg_recording"
                type="create"
                body={<EntityForm groupsOptions={eegRecordingOptions.groupsOptions} />}
            />
        ),
    },
    {
        path: "/eeg_comparison",
        element: <EEGAnalysis type="comparison" />,
    },
];
